export default {
  SET_ONLINE_STATUS(state, data) { state.onlineStatus = data; },
};
